export default __webpack_public_path__ + "static/media/SVGLogo.8bad0467.svg";